import PublishIcon from '@material-ui/icons/Publish';
import withGS from './withGShoc';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import EmojiObjectsIcon from '@material-ui/icons/EmojiObjects';
import IconButton from '@material-ui/core/IconButton';
import EditIcon from '@material-ui/icons/Edit';
import GetAppIcon from '@material-ui/icons/GetApp';
import LinearScaleIcon from '@material-ui/icons/LinearScale';
import AssignmentIcon from '@material-ui/icons/Assignment';
import HistoryIcon from '@material-ui/icons/History';
import InsertChartIcon from '@material-ui/icons/InsertChartOutlined';
import AccountTreeIcon from '@material-ui/icons/AccountTree';
import LowPriorityIcon from '@material-ui/icons/LowPriority';
import Tooltip from '@material-ui/core/Tooltip';
import { globalStyles } from './style/gstheme';
import { STATUS_ACCEPTED, STATUS_REJECTED } from './utils/constants';

const APPROVED = STATUS_ACCEPTED;
const REJECTED = STATUS_REJECTED;

const styles = () => {
  return Object.assign({
    options: {
      float: 'left',
      position: 'relative',
      top: 3,
      bottom: 0,
      paddingLeft: '5px'
    },
    count: {
      backgroundColor: '#CA4F0C',
      borderRadius: '50%',
      color: 'white',
      margin: '-20px 0px 0px -34px',
      fontSize: '12px',
      display: 'inline-block',
      paddingTop: '2px',
      width: '20px',
      textAlign: 'center',
      verticalAlign: 'middle',
      height: '16px'
    }
  }, globalStyles);
};

class DataOptions extends Component {

  changeView = (index) => this.props.changeView(index);

  optionItem = (index, icon, title, count) =>
    <div key={index} style={{ marginBottom: 18, paddingLeft: '7px' }} onClick={() => this.changeView(index)}>
      <Tooltip title={title}>
        <span>
          <IconButton
            aria-label={title}
            data-test={"option-" + title}
            size="small"
            classes={this.props.view === index ? {
              root: this.props.classes.selectedOption
            } : null}>
            {icon}
          </IconButton>
          {count && count > 0 ? <span data-test="option-count" className={this.props.classes.count}>{count}</span> : null}
        </span>
      </Tooltip>
    </div>;

  render() {

    const { classes, suggestionCount, data, useWorkflow } = this.props;
    const isDeleted = data.pendingDeletion || data._notAvailable;
    const isApproved = useWorkflow && "status" in data && data.status[0] === APPROVED ? true : false;
    const isRejected = useWorkflow && "status" in data && data.status[0] === REJECTED ? true : false;

    let options = [];
    options.push(this.optionItem(0, <EditIcon />, "Edit"));
    options.push(this.optionItem(1, <LinearScaleIcon />, "View RDF"));
    this.props.statsOption && options.push(this.optionItem(2, <InsertChartIcon />, "Statistics"));
    this.props.qualityOption && options.push(this.optionItem(3, <AssignmentIcon />, "Quality"));
    this.props.historyOption && options.push(this.optionItem(4, <HistoryIcon />, "History"));
    // If deleted we override any props
    if (!isDeleted) {
      this.props.suggestionOption && options.push(this.optionItem(5, <EmojiObjectsIcon />, "Suggestions", suggestionCount));
      if (!isApproved && !isRejected) {
        this.props.importOption && options.push(this.optionItem(7, <PublishIcon />, "Merge Data"));
      }
      this.props.exportOption && options.push(this.optionItem(6, <GetAppIcon />, "Export"));
      this.props.positioningOption && options.push(this.optionItem(8, <AccountTreeIcon />, "View Positioning"));
      this.props.inboundOption && options.push(this.optionItem(9, <LowPriorityIcon />, "Inbound Relationships"));
    }

    return (
      <div className={classes.options}>
        {options}
      </div>
    );
  }

}

DataOptions.defaultProps = {
  qualityOption: false,
  exportOption: false,
  importOption: false,
  statsOption: false,
  historyOption: false,
  suggestionOption: false,
  positioningOption: false,
  annotationOption: false,
  inboundOption: false,
  useWorkflow: false,
  suggestionCount: 0
};

DataOptions.propTypes = {
  changeView: PropTypes.func.isRequired,
  qualityOption: PropTypes.bool,
  exportOption: PropTypes.bool,
  importOption: PropTypes.bool,
  statsOption: PropTypes.bool,
  historyOption: PropTypes.bool,
  suggestionOption: PropTypes.bool,
  annotationOption: PropTypes.bool,
  positioningOption: PropTypes.bool,
  useWorkflow: PropTypes.bool,
  suggestionCount: PropTypes.number,
  inboundOption: PropTypes.bool,
  view: PropTypes.number,
  classes: PropTypes.object
};

export default withStyles(styles)(withGS(DataOptions, ["ALL"], null, {}, true));